import { SET_VERSION, OPEN_REFRESH_DIALOG, CLOSE_REFRESH_DIALOG } from '../../constant';

const initState = { version: null, open: false };

const versionReducer = (state = initState, action) => {
  const type = action.type;
  switch (type) {
    case SET_VERSION:
      const currentVersion = action.version;
      const version = state.version;
      if (version === null) {
        return { ...state, version: currentVersion };
      }

      if (version !== null && version !== currentVersion) {
        return { ...state, open: true };
      }
      return { ...state };
    case OPEN_REFRESH_DIALOG:
      return { ...state, open: true };
    case CLOSE_REFRESH_DIALOG:
      return { ...state, open: false };
    default:
      return state;
  }
};

export { versionReducer };
